import React from "react";
import PropTypes from "prop-types";
import {Link} from "gatsby"

function Blog({ posts }) {
  posts.unshift({
    excerpt: 'Handcrafted list of my favorite Black Friday week deals',
    fields: {
      slug: 'black-friday-2021'
    },
    frontmatter: {
      date: 'November 25, 2021',
      title: 'Black Friday Deals 2021',
      description: 'Handcrafted list of my favorite Black Friday week deals'
    }
  });
  return (
    <section className="bg-white border-b py-8" id="blog">
      <div className="container max-w-5xl mx-auto m-8">
        <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">Blog</h1>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"/>
        </div>

        <div className="w-full grid md:grid-cols-3 gap-5 sm:grid-cols-1">
          {posts.map((post, key) => (
            <Link to={post.fields.slug} key={key}>
              <div className="max-w-sm rounded overflow-hidden shadow mx-auto mb-8 hover:shadow-xl duration-500 transition ease-in-out" key={key}>
                <div className="px-6 py-4">
                  <small>{post.frontmatter.date}</small>
                  <div className="font-bold text-xl mb-2">{post.frontmatter.title}</div>
                  <p className="text-gray-700 text-base">
                    {post.frontmatter.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Blog;

Blog.propTypes = {
  posts: PropTypes.array
}
